import Vue from 'vue';
import App from './App.vue';
import { BootstrapVue, BootstrapVueIcons } from "bootstrap-vue";
import L from "leaflet";
import router from './router';
import VueScreen from 'vue-screen';
import store from "./store/";
import VueGtag from 'vue-gtag';

Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(VueScreen, {
  extend: 'bootstrap',
  mobileLandscape: screen => screen.landscape && screen.touch,
  breakpoint(screen) {
    if (screen.xl) {
      return 'xl';
    }
    if (screen.lg) {
      return 'lg';
    }
    if (screen.md) {
      return 'md';
    }
    if (screen.sm) {
      return 'sm';
    }
    return 'xs';
  },
  device(screen) {
    if (screen.xl) {
      return 'Widescreen';
    }
    if (screen.lg && !screen.touch) {
      return 'Desktop';
    }
    if (screen.md) {
      return 'Tablet';
    }
    return 'Phone';
  }
});
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_GOOGLE_ANALYTICS_CODE }
}, router);

delete L.Icon.Default.prototype._getIconUrl
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
})

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  console.error("Error:", err);
  console.error("Vue component:", vm);
  console.error("Additional info:", info);
};

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

